import BemIt, { addClass } from "@gtechdoodler/bem-it";
import StyledMembershipBadge from "./MembershipBadge.styles";
import { MembershipBadgeProps } from "./MembershipBadge.types";

const MembershipBadge: React.FC<MembershipBadgeProps> = ({
	className,
	iconPosition,
	size = "lg",
	variant = "blue",
	...props
}) => {
	const block = new BemIt("MembershipBadge");

	return (
		<StyledMembershipBadge
			className={addClass(className).after(block.mod(size))}
			iconPosition={iconPosition}
			size={size}
			variant={variant}
			{...props}
		/>
	);
};

export default MembershipBadge;
